/**
 * @param {*} minWidthPx the width at which the minimum size is rendered
 * @param {*} maxWidthPx the width at which the maximum size is rendered
 * @param {*} minSizeRem the min size of the clamped prop
 * @param {*} maxSizeRem the max size of the clamped prop
 * @returns A clamp declaration with min size, preferred size, and max size
 */
const clampBuilder = (minWidthPx, maxWidthPx, minSizeRem, maxSizeRem) => {
  const pixelsPerRem = 10;

  const minWidth = minWidthPx / pixelsPerRem;
  const maxWidth = maxWidthPx / pixelsPerRem;

  const slope = (maxSizeRem - minSizeRem) / (maxWidth - minWidth);
  const yAxisIntersection = -minWidth * slope + minSizeRem;

  return `clamp( ${minSizeRem}rem, ${yAxisIntersection}rem + ${slope * 100}vw, ${maxSizeRem}rem )`;
};

export default clampBuilder;
